<template>
      <!-- <Transition name="slide"> -->
            <div class="offcanvas">
                <slot></slot>
            </div>
    <!-- </Transition> -->
</template>

<script setup>

</script>

<style scoped>
.offcanvas {
    @apply w-full h-full bg-transparent fixed top-0 bottom-0 left-0 right-0 z-50 transition-all;
}
/* @keyframes slide {
    0% {
        opacity: 0;
        transform: translateX(100%);
    }
    100% {
        opacity: 1;
        transform: translateX(0);
    }
}

.slide-enter-active {
    animation: slide 0.5s;
}

.slide-leave-active {
    animation: slide 0.5s reverse;
}
.slide-enter-from,
.slide-leave-to {
  transform: translateX(30px);
  opacity: 0;
} */

/* @keyframes slide {
    0% {
        opacity: 0;
        transform: translateX(100%);
    }
    100% {
        opacity: 1;
        transform: translateX(0);
    }
}

.slide-enter-active {
    animation: slide 0.5s;
}

.slide-leave-active {
    animation: slide 0.5s reverse;
} */
</style>
